const USER = 'user'
const LOGIN_MESSAGE_KEY = 'uca-lms-login-message'
import {router} from '../router'
import { limparSessaoNotificacoes } from './notificacao.cache.service'

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === USER && event.newValue) {
      window.dispatchEvent(new CustomEvent('uca-lms-user-updated'))
    }
  })
}

export default {
  LOGIN_MESSAGE_KEY,
  setLoginMessage(message) {
    if (message) {
      window.sessionStorage.setItem(LOGIN_MESSAGE_KEY, message)
    }
  },
  consumeLoginMessage() {
    const message = window.sessionStorage.getItem(LOGIN_MESSAGE_KEY)
    if (message) {
      window.sessionStorage.removeItem(LOGIN_MESSAGE_KEY)
    }
    return message
  },
  getLocalUser(message = true) {

    if (window.localStorage.getItem(USER) && window.localStorage.getItem(USER) !== undefined)
      return JSON.parse(window.localStorage.getItem(USER))

    if (message) {
      console.log("[user.service] Sessão de usuário não encontrada");
      swalToast.fire('', 'Sessão não encontrada, entre novamente com a sua conta', 'warning');
      router.push("/login")
    }

    return undefined;

  },
  getUser() {
    const user = this.getLocalUser(false)
    return user?.Usuario?.Usuario
  },
  getRotaMensagensPrefixo() {
    const user = this.getUser()
    const modoAluno = !!window.localStorage.getItem('idModoAluno')
    if (user?.TipoUsuario === 'aluno' || modoAluno) {
      return 'aluno'
    }
    return 'academico'
  },
  getRotaMensagens(tipo) {
    const prefixo = this.getRotaMensagensPrefixo()
    if (tipo === 'notificacao') {
      return `/${prefixo}/mensagens/notificacao`
    }
    return `/${prefixo}/mensagens`
  },
  getPermissions() {
    const user = this.getLocalUser()
    return user.Usuario.Permissoes
  },
  getModalidade() {
    const user = this.getLocalUser()
    return user.Usuario.Modalidade
  },
  getFranqueados() {
    return this.getLocalUser(false)?.Usuario?.Franqueados ?? []
  },
  getFranqueadoUnidades() {
    return this.getLocalUser(false)?.Usuario?.FranqueadoUnidades ?? []
  },
  /**
   * Lista plana Franqueado (disabled) + Unidades para MultselectForm hierárquico,
   * a partir dos dados já presentes na sessão/JWT.
   */
  getFranqueadoUnidadeOptions() {
    const franqueados = this.getFranqueados()
    const unidades = this.getFranqueadoUnidades()
    if (!franqueados.length)
      return []

    const unidadesPorFranqueado = {}
    unidades.forEach((unidade) => {
      if (unidade.Desativado)
        return
      const idFranqueado = unidade.IdFranqueado
      if (!unidadesPorFranqueado[idFranqueado])
        unidadesPorFranqueado[idFranqueado] = []
      unidadesPorFranqueado[idFranqueado].push(unidade)
    })

    const lista = []
    let ordemFranqueado = 0

    franqueados.forEach((franqueado) => {
      if (franqueado.Desativado)
        return

      const unidadesFranqueado = unidadesPorFranqueado[franqueado.Id] ?? []
      if (!unidadesFranqueado.length)
        return

      ordemFranqueado++
      lista.push({
        Id: 'F-' + franqueado.Id,
        IdFranqueado: franqueado.Id,
        IdFranqueadoUnidade: null,
        Nome: franqueado.FranqueadoNome,
        Tipo: 'Franqueado',
        disabled: true,
        level: String(ordemFranqueado),
        searchText: franqueado.FranqueadoNome,
      })

      unidadesFranqueado.forEach((unidade, index) => {
        lista.push({
          Id: unidade.Id,
          IdFranqueado: franqueado.Id,
          IdFranqueadoUnidade: unidade.Id,
          Nome: unidade.FranqueadoUnidadeNome,
          Tipo: 'Unidade',
          disabled: false,
          level: `${ordemFranqueado}.${index + 1}`,
          searchText: `${franqueado.FranqueadoNome} ${unidade.FranqueadoUnidadeNome}`.trim(),
        })
      })
    })

    return lista
  },
  findFranqueadoUnidadeOption(idFranqueadoUnidade) {
    if (idFranqueadoUnidade == null || idFranqueadoUnidade === '')
      return null
    return this.getFranqueadoUnidadeOptions()
      .find((item) => item.IdFranqueadoUnidade == idFranqueadoUnidade) ?? null
  },
  isAdmin() {
    const user = this.getUser()
    if (user.Admin)
      return true
    return false
  },
  checkPermision(controller) {
    const user = this.getLocalUser()
    if (!user)
      return false

    if (user.Usuario.Usuario.Admin)
      return true

    return user.Usuario.Permissoes.some(i => i.Controller == controller);

  },
  saveUser(user) {
    const session = {
      ...user,
      requested: Date.now()
    }
    window.localStorage.setItem(USER, JSON.stringify(session))
    window.dispatchEvent(new CustomEvent('uca-lms-user-updated'))
  },
  onUserUpdated(callback) {
    window.addEventListener('uca-lms-user-updated', callback)
    return () => window.removeEventListener('uca-lms-user-updated', callback)
  },
  destroyUser() {
    window.localStorage.removeItem(USER)
    limparSessaoNotificacoes()
  },
  isAuthenticated() {
    return (
    window.localStorage.getItem(USER) &&
    window.localStorage.getItem(USER) != 'undefined'
    )
  },
}
